import styles from "./BallroomCard.module.css";
import { useNavigate } from "react-router-dom";
export default function BallroomCard({
  ballroom,
  hotel,
  onClick,
}) {

    console.log(ballroom);
console.log(ballroom.slug);
  const largestCapacity =

    ballroom.capacities?.reduce(
      (max, item) => Math.max(max, item.capacity || 0),
      0
    ) || 0;

  const image =
    ballroom.images?.[0]?.image ||
    hotel.featured_image;
    const navigate = useNavigate();



    const hasCapacity = largestCapacity > 0;
const hasArea = !!ballroom.carpet_area;
const hasHeight = !!ballroom.ceiling_height;

  return (
    
    <div className={styles.card}>

      <img
        src={image}
        alt={ballroom.name}
        className={styles.image}
      />

      <div className={styles.content}>

        <span className={styles.hotel}>
          {hotel.name}
        </span>

        <h3>{ballroom.name}</h3>

        {/* <div className={styles.stats}>

          <div>
            <strong>{largestCapacity}</strong>
            <span>Guests</span>
          </div>

          <div>
            <strong>
              {ballroom.carpet_area || "-"}
            </strong>
            <span>Sq Ft</span>
          </div>

          <div>
            <strong>
              {ballroom.ceiling_height || "-"}
            </strong>
            <span>Height</span>
          </div>

        </div> */}

        <div className={styles.stats}>

  {hasCapacity && (
    <div>
      <strong>{largestCapacity}+</strong>
      <span>Guests</span>
    </div>
  )}

  {hasArea && (
    <div>
      <strong>{ballroom.carpet_area}</strong>
      <span>Sq. Ft Area</span>
    </div>
  )}


</div>


<button
  className={styles.button}
  onClick={() =>
    navigate(`/venue-planner/hotel/${hotel.slug}/ballroom/${ballroom.slug}`)
  }
>
  Explore Ballroom
</button>
      </div>

    </div>
  );
}